<script>
import Layout from '@/components/layout/app-layout'
import appConfig from '@/app.config'
import PageHeader from '@/components/layout/page-header'
import tableMixin from '@/mixins/table'
import api from '@/helpers/api'
/**
 * Dashboard Component
 */
export default {
  name: 'crm.customers.list',
  mixins: [tableMixin],
  page: {
    title: 'Sales - Customers',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  data () {
    return {
      isLoading: false,
      title: 'Customers',
      search: null,
      newCustomerFormVisible: false
    }
  },
  mounted () {
    this.onRefresh()
  },
  watch: {
    search: 'onRefresh',
    currentPage: 'onRefresh',
    perPage: 'onRefresh'
  },
  methods: {
    async onRefresh () {
      this.isLoading = true
      let { items, total_rows } = await api.customers.fetchPage({
        page: this.currentPage,
        pageSize: this.perPage === 'All' ? -1 : this.perPage,
        needle: this.search
      })

      this.data = items
      this.totalRows = total_rows
      this.isLoading = false
    }
  },
  computed: {
    breadcrumbs () {
      return [
        {
          text: 'Sales',
          to: { name: 'sales' }
        },
        {
          text: 'Customers',
          active: true
        }
      ]
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="breadcrumbs"> </PageHeader>
    <div class="mb-4 d-flex justify-content-between align-items-center">
      <g-search-input
        v-model="search"
        placeholder="Find customers"
        width="300px"
        class="mr-0 mr-2"
      /><b-btn
        class="btn-label"
        variant="primary"
        v-on:click="newCustomerFormVisible = true"
      >
        <i class="bx bx-plus label-icon"></i>New
      </b-btn>
    </div>
    <g-overlay :show="isLoading">
      <div class="row">
        <div
          v-for="customer in data"
          :key="customer.id"
          class="col-xl-3 col-lg-3 col-md-4 col-sm-6"
        >
          <app-customer-grid-card :customer="customer" />
        </div>

        <b-col
          v-if="data.length === 0"
          align-self="center"
          class="text-center py-5"
        >
          <b-icon
            icon="cloud-slash"
            variant="dark"
            scale="4"
            class="m-4"
          ></b-icon>

          <h4>No Customers Yet!</h4>
        </b-col>
      </div>
      <div class="d-flex align-items-center justify-content-between p-0 mt-2">
        <div class="dataTables_length" v-if="totalRows > minPerPage">
          <label class="d-inline-flex align-items-center m-0">
            Show
            <b-form-select
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="mx-2"
            ></b-form-select
            >Entries
          </label>
        </div>

        <b-pagination
          v-if="perPage !== 'All' && totalRows > perPage"
          class="pagination mb-0"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          size="sm"
        >
          <template v-slot:page="{ page, active }">
            <b v-if="active">{{ page }}</b>
            <i v-else>{{ page }}</i>
          </template>
        </b-pagination>
      </div>

      <!-- end row -->
    </g-overlay>
    <app-customer-form-dialog
      :visible.sync="newCustomerFormVisible"
      v-on:created="onRefresh"
    />
  </Layout>
</template>
